/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_LIST(state, data) {
    state.list = data.items;
    state.classesWithoutGroups = data.items.filter((item) => {
      return item.group_id === null || item.group_id === undefined;
    });
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_DETAIL(state, erpclass) {
    state.selecting = erpclass;
  },
  ADD_CLASS(state, data) {
    console.log("ADD CLASS", data);
    state.list.unshift(data);
    // Để không phải load toàn bộ class,
    // Thì ở đây sẽ map class_name (case user thay đổi class_name)
    // cho tất cả class cùng nhóm với nó (booking sẽ có 1 nhóm các class)
    if (data.group_id !== null) {
      state.list = state.list.map((item) => {
        if (data.group_id === item.group_id || data.group_id === item.id) {
          item.class_name = data.class_name;
          item.timetables = item.timetables.map((e) => {
            e.class.class_name = data.class_name;
            return e;
          });
        }
        return item;
      });
    }
    state.classesWithoutGroups = state.list.filter((item) => {
      return item.group_id === null || item.group_id === undefined;
    });
  },
  UPDATE_CLASS(state, data) {
    const pos = state.list
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.list.splice(pos, 1, data);

    console.log("UPDATE CLASS", pos, data);
    // Để không phải load toàn bộ class,
    // Thì ở đây sẽ map class_name (case user thay đổi class_name)
    // cho tất cả class cùng nhóm với nó (booking sẽ có 1 nhóm các class)
    if (data.group_id !== null) {
      state.list = state.list.map((item) => {
        if (data.group_id === item.group_id || data.group_id === item.id) {
          item.class_name = data.class_name;
          item.timetables = item.timetables.map((e) => {
            e.class.class_name = data.class_name;
            return e;
          });
        }
        return item;
      });
    }
    state.classesWithoutGroups = state.list.filter((item) => {
      return item.group_id === null || item.group_id === undefined;
    });
  },
  syncTimetables(state, data) {
    // Để không phải load toàn bộ class,
    // Thì ở đây sẽ map class_name (case user thay đổi class_name)
    // cho tất cả class cùng nhóm với nó (booking sẽ có 1 nhóm các class)
    if (data.group_id !== null) {
      state.list = state.list.map((item) => {
        if (data.group_id === item.group_id || data.group_id === item.id) {
          item.class_name = data.class_name;
          item.timetables = item.timetables.map((e) => {
            e.class.class_name = data.class_name;
            return e;
          });
        }
        return item;
      });
    }
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  CLASS_FILTER(state, data) {
    console.log("filter classes", data);
    state.classesWithFilters = (data?.items || state.list).filter((item) => {
      return (
        // (item.group_id === null || item.group_id === undefined) //Xóa  class cùng 1 group
        //state.filters?.status.includes(item?.timetable?.slot_status) // filter theo status
        state.filters?.id.includes(item.schedule_setting_id) // filter theo setting
      );
    });
  },
  TIMETABLES_FILTER(state, data) {
    console.log("filter timetables", data);
    state.timetables = (data?.items || state.list)
      .filter((item) => {
        return (
          state.filters?.status.includes(item.status) &&
          state.filters?.id.includes(item.schedule_setting_id)
        );
      })
      .map((item) => {
        return item.timetables?.map((item) => {
          return item.fullcalendar;
        });
      })
      .flat()
      .filter((item) => {
        return item;
      });
  },
  SET_FILTERS(state, data) {
    state.filters = data;
  },
};
